{
  "id": "campaign-068",
  "name": "Windy Dogleg",
  "seed": "campaign:68",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....W....,W",
    ".........,,.",
    "..........,.",
    "....T.......",
    "....ooo.,,..",
    "T~~~oFosss..",
    "..~.oooh.T.*",
    "..........**",
    "........b..*",
    "............",
    "....W.......",
    "............",
    "x......x..#.",
    "..h.........",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 0,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 4
    },
    {
      "kind": "rare",
      "x": 8,
      "y": 5
    }
  ],
  "generatorVersion": 3,
  "level": 68,
  "biome": "golf",
  "par": {
    "reel": 6726,
    "push": 5619,
    "selfPropelled": 5280,
    "tractor": 4540,
    "zeroTurn": 3448,
    "fairway": 2224
  },
  "routeTries": {
    "par": {
      "reel": 22,
      "push": 11,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 3,
      "fairway": 22
    }
  }
}
